import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.abortController = new AbortController()
    this.element.addEventListener("change", event => this.navigate(event), { capture: true, signal: this.abortController.signal })
  }

  disconnect() { this.abortController.abort() }

  navigate(event) {
    if (!event.target.closest(".app-pagination")) return
    const pending = [...this.element.querySelectorAll(".allocation-amount, .settlement-amount")]
      .some(input => Number(input.value) !== 0 && input.value.trim() !== "")
    if (!pending) return
    event.preventDefault()
    event.stopImmediatePropagation()
    if (event.target.matches("select")) {
      event.target.value = [...event.target.options].find(option => option.defaultSelected)?.value || event.target.value
    }
    window.showToast?.("Apply or clear this page's allocations before moving to another page.", "warning")
  }
}
